import PhoneInput from 'react-phone-input-2';
import { Box, InputLabel } from '@mui/material';
import 'react-phone-input-2/lib/style.css';
import './CustomTextField.scss';
import { useEffect, useRef, useState } from 'react';

type CustomTextFieldProps = {
  id?: string;
  label?: string;
  color?: 'primary' | 'secondary';
  error?: boolean;
  style?: string;
  helperText?: any;
  value?: string;
  onChange?: any;
  disabled?: boolean;
  placeholder?: string;
  setValue?: any;
  country?: string;
  name?: any;
  isOptional?: boolean;
  getValues?: any;
  disableCountry?: boolean;
  margin?: any;
};

function PhoneNoTextField({
  label,
  value,
  onChange,
  disabled,
  setValue,
  error = false,
  country,
  style,
  name,
  disableCountry = false,
  isOptional,
  helperText,
  getValues,
  margin = '10px'
}: CustomTextFieldProps) {
  const inputStyle = {
    border: '1px solid #d32f2f'
  };
  const countryCode: any = useRef();
  const [isCountry, setIsCountry] = useState(0);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (countryCode?.current && getValues && !getValues(name)) {
      setIsCountry(prev => prev + 1);
    }
  }, [countryCode.current, getValues && getValues(name)]);

  return (
    <Box className='custom-phone-input-container' key={isCountry}>
      <InputLabel id='phone-label'>
        {label}
        {!isOptional && label ? <span style={{ color: 'red' }}> *</span> : ''}
      </InputLabel>
      <Box sx={{ marginBottom: margin }}>
        <PhoneInput
          placeholder={label ? label : 'Mobile Number'}
          // alwaysDefaultMask
          copyNumbersOnly={false}
          disabled={disabled}
          disableDropdown={disableCountry}
          countryCodeEditable={country ? false : true}
          value={`${value}`}
          country={country ? country : undefined}
          // onChange={(value, formattedValue: any) => {
          //   const regex = new RegExp(`^${formattedValue?.dialCode}`);
          //   const number = value.replace(regex, '');
          //   if (countryCode.current && !value) {
          //     setIsCountry(prev => prev + 1);
          //   }
          //   countryCode.current = value;
          //   if (formattedValue)
          //     if (onChange)
          //       onChange(
          //         label === 'Contact Number'
          //           ? `+${formattedValue?.dialCode}-${number}`
          //           : value
          //       );
          //   setValue(
          //     name,
          //     label === 'Contact Number'
          //       ? `+${formattedValue?.dialCode}-${number}`
          //       : value
          //   );
          // }}
          onChange={(value, formattedValue: any) => {
            const regex = new RegExp(`^${formattedValue?.dialCode}`);
            const number = value.replace(regex, '');
            if (countryCode?.current && !value) {
              setIsCountry(prev => prev + 1);
            }
            const dialCode = formattedValue?.dialCode;
            let formattedNumber = value;
            if (formattedValue)
              if (value?.match(regex)) {
                const number = value.replace(regex, '').trim();
                formattedNumber = `+${dialCode}-${number}`;
              }
            onChange(formattedNumber);
            setValue(name, formattedNumber);
          }}
          inputStyle={
            error
              ? inputStyle
              : { border: '1px solid #ccc', height: style === 'share' ? '36px' : '55px' }
          }
          // inputProps={{
          //   ref: inputRef,
          //   onKeyDown: (e: any) => {
          //     if (disableCountry) {
          //       const position = e.currentTarget.selectionStart ?? 0;
          //       const countryToDialCode: any = {
          //         in: '91',
          //         sg: '65',
          //         uae: '971'
          //       };
          //       const dialCode = countryToDialCode[country?.toLowerCase() || ''] ?? '';
          //       if (
          //         (e.key === 'Backspace' || e.key === 'Delete') &&
          //         (/^(0|[1-9][0-9]*)$/.test(e.key) || position <= dialCode?.length + 1) // +1 for '+' sign
          //       ) {
          //         e.preventDefault();
          //       }
          //     }
          //   }
          // }}
        />
        {error && <Box className='phoneNo-error'>{helperText}</Box>}
      </Box>
    </Box>
  );
}

export default PhoneNoTextField;
